import { Action, createReducer, on } from '@ngrx/store';
import { getArticlesAction, getArticlesActionFailure, getArticlesActionSuccess } from './articles.actions';
import { ArticlesListState } from './articles.state';

const initialArticlesListState: ArticlesListState = {
  articles: null,
  isLoading: false,
  error: false,
};

const reducer = createReducer(
  initialArticlesListState,
  on(getArticlesAction, (state) => ({
    ...state,
    isLoading: true,
    error: false,
  })),

  on(getArticlesActionSuccess, (state, res) => ({
    ...state,
    articles: res.data,
    isLoading: false,
    error: false,
  })),

  on(getArticlesActionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    errors: error,
  })),
);

export const articlesReducer = (state: ArticlesListState = initialArticlesListState, action: Action): ArticlesListState =>
  reducer(state, action);
